/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useContext,
  memo,
  useMemo,
} from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import { colors } from 'styles/variables';
import getTempTextImageData from 'services/getTempTextImageContinueBtnData';
import expandBlock from 'services/apiHelpers/expandBlock';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column, Button, Box } from '@chameleoncreator/creator-ui';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import EditableBtn from 'components/lib/EditableBtn';
import Container from 'components/Layouts/ContainerLogical';
import { connect } from 'react-redux';
import { interactionContext } from './interactionContext';
import Media from 'components/lib/Media';
import Embed from 'components/lib/Embed';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import shouldUpdate from 'services/shouldUpdate';
import IELayout from 'components/Layouts/IELayout';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: EditableText,
  Image: ({ children, ...props }) => {
    return <Image {...{ ...props, usePlaceholderValue: true }} />;
  },
  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: EditableBtn,
  Video,
  SVG,
  Media,
  Embed,
  Transcript: ({ children, ...props }) => children,
  ...IELayout(interactionContext),
};

const MultiMediaDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{
          ...interactionBlock,
          isOpen: props.isOpen,
          updateItemsSeen: null,
        }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate);

// const MultiMediaDisplay = props => {
//   const interactionBlock = getBlockById(props.blockId);

//   const container = (
//     <Container
//       id={interactionBlock.id}
//       key={interactionBlock.id}
//       {...interactionBlock.props}
//       {...props}
//     >
//       <interactionContext.Provider
//         value={{
//           ...interactionBlock,
//           isOpen: props.isOpen,
//           updateItemsSeen: null,
//         }}
//       >
//         {(interactionBlock.children as Block[]).map(child => {
//           return renderBlock(child, Components);
//         })}
//       </interactionContext.Provider>
//     </Container>
//   );

//   return window.dev()
//     ? container
//     : useMemo(() => {
//         // console.log('multimedia renders');
//         return container;
//       }, [props.isOpen, interactionBlock.props.lockDown]);
// };

export default MultiMediaDisplay;
